// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class GreenleafAssessment extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		this.scaleX = 4;
		this.scaleY = 4;

		// mentorSprite
		const mentorSprite = scene.add.sprite(0, 0, "npc-mentor-e_1");
		mentorSprite.setOrigin(0.5, 0.68);
		this.add(mentorSprite);

		this.mentorSprite = mentorSprite;

		/* START-USER-CTR-CODE */

    this.createAnimations();

    /* END-USER-CTR-CODE */
	}

	private mentorSprite: Phaser.GameObjects.Sprite;

	/* START-USER-CODE */
  animInterval?: NodeJS.Timeout;

  // Copies the same way animations are set up in the mentor classes.
  createAnimations() {
    this.mentorSprite.play('mentor-e-idle-1');

    this.animInterval = setInterval(() => {
      this.mentorSprite.play({
        key: 'mentor-e-idle-2',
        repeat: 0,
      });
      this.mentorSprite.on('animationcomplete-mentor-e-idle-2', () => {
        this.mentorSprite.play('mentor-e-idle-1');
      });
    }, 5000);

    this.scene.events.on('destroy', this.handleSceneDestroyed, this);
    this.scene.events.on('shutdown', this.handleSceneDestroyed, this);
  }

  handleSceneDestroyed() {
    clearInterval(this.animInterval);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
